/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CreateDateTime } from './createDateTime';
import { ExternalKey } from './externalKey';
import { ExternalKeys } from './externalKeys';
import { LastUpdateByUserId } from './lastUpdateByUserId';
import { StockTransferDetailsListViewFactorCalculations } from './stockTransferDetailsListViewFactorCalculations';
import { StockTransferDetailsListViewStock } from './stockTransferDetailsListViewStock';
import { StockTransferDetailsListViewStockTransferHeaders } from './stockTransferDetailsListViewStockTransferHeaders';
import { UpdateDateTime } from './updateDateTime';

export interface StockTransferDetailsListView { 
    /**
     * The unique identifier of this record.
     */
    transferDetailId?: number;
    /**
     * A reference to the primary key in the StockTransferHeaders Table
     */
    transferId?: number;
    /**
     * A reference to the primary key in the Stock Table
     */
    stockId?: number;
    destinationQtyInStock?: number;
    sourceQtyInStock?: number;
    qtyToTransfer?: number;
    valueToTransfer?: number;
    destMax?: number;
    destMin?: number;
    destQtyInStkAfter?: number;
    createDateTime?: CreateDateTime;
    updateDateTime?: UpdateDateTime;
    lastUpdateByUserId?: LastUpdateByUserId;
    externalKeys?: ExternalKeys;
    externalKey?: ExternalKey;
    avgCost?: number;
    unitQtyToTransfer?: number;
    unitType?: StockTransferDetailsListView.UnitTypeEnum;
    /**
     * A reference to the primary key in the Factors Table
     */
    factorId?: number;
    factorCalculations?: StockTransferDetailsListViewFactorCalculations;
    Stock?: StockTransferDetailsListViewStock;
    stockTransferHeaders?: StockTransferDetailsListViewStockTransferHeaders;
}
export namespace StockTransferDetailsListView {
    export type UnitTypeEnum = 'Factor' | 'Inner' | 'Outer' | 'null';
    export const UnitTypeEnum = {
        Factor: 'Factor' as UnitTypeEnum,
        Inner: 'Inner' as UnitTypeEnum,
        Outer: 'Outer' as UnitTypeEnum,
        Null: 'null' as UnitTypeEnum
    };
}